import { combineReducers } from "@reduxjs/toolkit";
import LayoutReducer from "./layouts/reducer";
import { baseApi } from "../redux/services/baseApi";

const rootreducer = combineReducers({
  Layout: LayoutReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export default rootreducer;